import * as PreferencesConstants from './preferences.constants';

export default PreferencesConstants;
